import { ChangeDetectionStrategy, Component } from '@angular/core';

import { filter, map, tap } from 'rxjs';

import { Post } from '@app/blog/interfaces/post';
import { BlogService } from '@app/blog/services/blog.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-sidenav-blog-block',
  templateUrl: './sidenav-blog-block.component.html',
  styleUrls: ['./sidenav-blog-block.component.scss'],
})
export class SidenavBlogBlockComponent {
  posts: Post[] | undefined;
  latestPost: Post | undefined;
  allPostsCount: number | undefined;
  lastPostSize = 3;
  getPosts$ = this.blogService.getPosts().pipe(
    filter((response) => response.posts.length > 0),
    map((response) => {
      return { latestPost: response.posts.shift()!, posts: response.posts };
    }),
    map((result) => {
      const excerpt = result.latestPost.excerpt ?? '';
      const excerptLength = Math.min(excerpt.length, 70);
      return {
        latestPost: {
          ...result.latestPost,
          excerpt: excerpt.substring(0, excerptLength).trimEnd() + '...',
        } as Post,
        posts: result.posts.slice(
          0,
          Math.min(result.posts.length, this.lastPostSize)
        ) as Post[],
        allPostsCount: result.posts.length,
      };
    }),
    tap((result) => {
      this.latestPost = result.latestPost;
      this.posts = result.posts;
      this.allPostsCount = result.allPostsCount;
    })
  );

  constructor(private readonly blogService: BlogService) {}
}
